module.exports = __webpack_public_path__ + "static/img/btn_lingqu.463bcac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/btn_lingqu.png
// module id = +k/O
// module chunks = 1